import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=3686a0b5&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3686a0b5",
  null
  
)

export default component.exports